  import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData,downloadExcelReports} from '../../../services/index';
import { Collapse,Popconfirm, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker,message,Select,Modal,DatePicker   } from 'antd';
import {  EditOutlined,SafetyCertificateOutlined,DeleteOutlined,DownloadOutlined,WhatsAppOutlined,MailOutlined } from '@ant-design/icons';
import Pagination from "react-js-pagination";
import FilterTable from "../../../component/transport-attendance";

const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}
const { Option } = Select;


const dateFormat = 'DD-MM-YYYY';

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			new_date: '',
			new_list: [],
			school_list: [],
			total_count:0,
			is_next:0,
			tag: '',
			page: 1,
			perPage: 10,
			selectedDate: null,
		}
		this.handleSizeChange = this.handleSizeChange.bind(this);
	}
	
	
	
	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
			var date = new Date().toLocaleString("en-US", {timeZone: "Asia/Kolkata"});
			const new_acad = (new Date().getFullYear())+'-'+ (new Date().getFullYear()+1);
			
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))
			var permission = storedArray['data'][0]['permission'];
			var user_type = storedArray['data'][0]['type'];
			setTimeout(() => {
				this.setState({ 
					user_id : storedArray['data'][0]['user_id'],
					school_id : storedArray['data'][0]['school_id'],
					permission : permission,
					user_type : user_type,
					academic_year : new_acad,
				});
			}, 50);
		}
		
			
		setTimeout(() => {
			this.checkData();
		}, 100);
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {school_id:school_id,user_id:user_id,route_id:this.props.match.params.id,type:this.props.match.params.text,date : this.state.selectedDate,tag:this.state.tag}
			getData('Transport/check_route_attendance',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							selectedDate: result['current_date'],
							new_date: result['new_date'],
							total_count: result['total_school'],
							is_next: result['is_next'],
							is_show: 1,
						});
					}else{
						this.setState({
							school_list: [],
							total_count: 0,
							is_show: 1,
						});
					}
				}
			});
	}
    }
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	};
	
	getPreviousDate = () => {
		this.setState({tag:'pre'});
		setTimeout(() => {
				this.checkData();
			}, 50);
	}
	
	getNextDate = () => {
		this.setState({tag:'nxt'});
		setTimeout(() => {
				this.checkData();
			}, 50);
	}
	
	DateChange(date, dateString) {
	    this.setState({ new_date: dateString,selectedDate: dateString,tag:'' });
	    setTimeout(() => {
			this.checkData();
		}, 50);
	}
	
	render()

	{
	const {aToken}=this.state;
	const { size } = this.state;
	
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<>
				
				
				<div class="row bred">
					<div class="col-md-12">
						<div class="card">
							<div class="card-body">
								<h4 class="page-title"> 
									<i class="mdi mdi-apple-keyboard-command title_icon"></i>Child Report
									<div class="breadcrumb-wrapper">
										<ol class="breadcrumb">
											<li class="breadcrumb-item">
												<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
												<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
												</a>
											</li>
											<li class="breadcrumb-item"> <a href={`${process.env.PUBLIC_URL}/transport-setup/check-route`} class="router-link-active" target="_self">Route Details</a> </li>
											<li class="breadcrumb-item"> Attendance </li>
										</ol>
									</div>
								</h4>
							</div>
						</div>
					</div>
				</div>
				
				<div class="row">
					<div class="col-md-12">
					<div class="card">
					<div class="card-body">
						
						<div class="row">
						<div class="col-md-5">
							<div class="form-group">
								<div class="iq-card date_range form-group d-flex">
								<svg onClick={this.getPreviousDate} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30"><path fill="none" d="M0 0h24v24H0z"/><path d="M10.828 12l4.95 4.95-1.414 1.414L8 12l6.364-6.364 1.414 1.414z" fill="rgba(70,70,70,1)"/></svg>
								
								{this.state.new_date !='' && (<>
								<DatePicker value={moment(this.state.new_date, dateFormat)} format={dateFormat} onChange={this.DateChange.bind(this)} className="att-fil-date"/>
								</>)}
								
								{(() => {
									if (this.state.is_next == '1') {
										return (
											<svg onClick={this.getNextDate} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30"><path fill="none" d="M0 0h24v24H0z"/><path d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z" fill="rgba(70,70,70,1)"/></svg>
										)
									}
								})()}
							</div>
							</div>
						</div>
						</div>
						
					</div>
					</div>
					</div>
				</div>
				
				
				
                <div class="">
                  <div class="row">
                     <div class="col-lg-12 mb-3 form-group">
					 <div class="card">
						<div class="card-body">
						<div class="row">
						<div class="col-sm-2 col-12 text-left  enquiry-btn mt-10">
							<h4 class="header-title mt-5px">Total Child : {this.state.total_count}</h4>
						</div>
						<div class="col-sm-10 col-12 text-right  enquiry-btn mt-5px">
							
						</div>
						</div>
						
                        <div class="table-responsive new-table">
                            <div class="hidden-xs mt-15">
							  <FilterTable 
									data={this.state.school_list}
									page_name='enquiries'
								/>
							</div>
                        </div>
                        </div>
                        </div>
                     </div>
                  </div>
               </div>
			   </>
		) 
	} 
}
export default Index;
